
  <div class="ui-g-12 ui-md-12 ui-lg-12 container-height h-400">
    <div id="driverLocationMap" class="map"></div>
  </div>


